import { render, staticRenderFns } from "./BrandChannelProposal.vue?vue&type=template&id=3f5d8244"
import script from "./BrandChannelProposal.vue?vue&type=script&lang=js"
export * from "./BrandChannelProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports